import {User} from '../models/user';
import {Store} from '@ngrx/store';
import {Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {UserActions} from '../store/actions/user.actions';
import {Angulartics2GoogleAnalytics} from 'angulartics2';
import {UserService} from '../services/user.service';

@Injectable()
export class AuthBasedGuard {

  protected isLogged: boolean;

  /**
   * Get the current user
   * @param {Router} router
   * @param {Store<any>} store
   * @param {AuthService} authService
   * @param {UserActions} userActions
   * @param {Angulartics2GoogleAnalytics} angulartics2GoogleAnalytics
   */
  constructor(protected router: Router,
              private store: Store<any>,
              protected authService: AuthService,
              protected userActions: UserActions,
              protected userService: UserService,
              protected angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics) {
    this.store.select('userState').subscribe((user: User) => {
      this.isLogged = !!user;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/routing/auth-based-guard.ts